import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core'

@Component({
    selector: 'lib-thruster-add',
    imports: [
        TranslatePipe
    ],
    templateUrl: './thruster-add.component.html',
    styleUrl: './thruster-add.component.scss'
})
export class ThrusterAddComponent {

}
